export default __webpack_public_path__ + "static/media/photo--lg--100.b85b961d.jpg";